import { render, staticRenderFns } from "./transferCreate.vue?vue&type=template&id=c5023460&scoped=true"
import script from "./transferCreate.vue?vue&type=script&lang=js"
export * from "./transferCreate.vue?vue&type=script&lang=js"
import style0 from "./transferCreate.vue?vue&type=style&index=0&id=c5023460&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5023460",
  null
  
)

export default component.exports